export const LOADING = "Main_LOADING";
export const API_SUCCESS = "Main_API_SUCCESS";
export const API_FAILURE = "Main_API_FAILURE";
export const USER_DATA_LOADED = "Main_USER_DATA_LOADED";
export const USER_DATA_UPDATED = "USER_DATA_UPDATED";
export const AVATARUPLOADING = "AVATARUPLOADING";
export const AVATARUPLOADED = "AVATARUPLOADED";
export const AVATARSAVING = "AVATARSAVING";
export const AVATARSAVED = "AVATARSAVED";
